const NotFound404Page = () => {
  const style = {
    marginTop: "50px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  };
  return <div style={style}>{"\u2728"} sorry, page not found</div>;
};

export default NotFound404Page;
